import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setDeploymentsList } from 'Workspace/Cohorts/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { cohortId } = action;

  const workspaceDeploymentsList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_DEPLOYMENT_LIST,
    cohortId,
  });

  if (workspaceDeploymentsList.type === constants.RTM_WORKSPACE_DEPLOYMENT_LIST_OK) {
    const deployments = workspaceDeploymentsList.response.deployments;
    yield put(setDeploymentsList(cohortId, deployments));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceDeploymentsListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_DEPLOYMENT_LIST, catchErrors, sendRequest, connection);
}
